module.exports = __webpack_public_path__ + "static/media/feature.94cf94b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyRunnersClub/feature.jpg
// module id = 287
// module chunks = 0